import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next} from 'react-i18next'

import en from './en/index.json'
import de from './de/index.json'
import fr from './fr/index.json'
import ar from './ar/index.json'
import ru from './ru/index.json'

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['ar', 'de', 'en', 'fr', 'ru'],
    debug: true,
    detection: {
      order: ['cookie', 'path', 'subdomain'],
      caches: ['cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {en, de, fr, ar, ru},
    react: {
      useSuspense: false,
    },
  })

export default i18n
